import type { ReactElement } from 'react';
import { EmptyState, PageHeader } from '@/shared/ui';

interface ComingSoonPageProps {
  /** GNB 메뉴 라벨과 동일한 페이지 제목. */
  readonly title: string;
}

/**
 * 아직 준비되지 않은 GNB 메뉴가 공유하는 자리표시 페이지 — 다른 화면과 같은 머리말 아래 카드 안 가운데 안내.
 * 셸(헤더 · 사이드바)은 레이아웃 라우트(app/admin-layout)가 제공한다.
 */
export const ComingSoonPage = ({ title }: ComingSoonPageProps): ReactElement => (
  <>
    <PageHeader title={title} />
    <EmptyState>페이지 준비 중입니다. 조금만 기다려 주세요.</EmptyState>
  </>
);
